<app-upgrade-one
        *ngIf="initialized && subscription"
        [productPrice]="pcOnePrice"
        [productDiscount]="pcOneDiscount"
        (back)="onBackChangeCu()"
        [subscription]="subscription"
        (next)="onProductSelected($event)">
</app-upgrade-one>
